// import PropTypes from 'prop-types';
import React, { ReactElement } from 'react';

import NoSSR from '../../../context/ssr/no-ssr';
import { isMobile, isServer } from '../../../utils/device-utils';
import { IClassNames, makeClassNames } from '../../../utils/styles';
import { IconCircleLeft, IconCircleRight } from '../../atoms';
import { IIcon } from '../../atoms/icons/icon';
import { IMatchChangeHp } from '../../molecules/match-change/match-change';
import GliderWrapper, { IGliderWrapper } from '../../organisms/glider-wrapper/glider-wrapper';
import MatchChangeTable, { IMatchChangeTable } from '../../organisms/match-change-table/match-change-table';

import './match-change-hp.scss';

export interface IMatchChangeHpTemplate {
  matchList: Array<IMatchChangeHp>;
  trackingData?: object;
}

// ARROWS (DESKTOP only)
const isClientDesktop: boolean = isServer() ? false : !isMobile() || false;
const iconLeft = (): ReactElement<IIcon> => <IconCircleLeft size="xsmall" color="light" />;
const iconRight = (): ReactElement<IIcon> => <IconCircleRight size="xsmall" color="light" />;

const argsGliderWrapper: IGliderWrapper<IMatchChangeTable> = {
  hasArrows: isClientDesktop,
  draggable: true,
  exactWidth: true,
  iconLeft: isClientDesktop ? iconLeft() : undefined,
  iconRight: isClientDesktop ? iconRight() : undefined,
  itemWidth: 180,
  scrollLock: false,
  Component: MatchChangeTable,
};

const classNames = (): IClassNames =>
  makeClassNames({
    wrapper: 'match-change-hp--wrapper',
  });

// Component to return when SERVER-SIDE (MatchChangeTable only, no Glider)
const ssrPlaceholder = (propsComponent: IMatchChangeTable, cn: IClassNames) => (
  <div className={cn.wrapper}>
    <MatchChangeTable {...propsComponent} isSSR />
  </div>
);

const MatchChangeHp: React.FC<IMatchChangeHpTemplate> = ({
  /* istanbul ignore next: default value */ matchList = [],
  trackingData,
}) => {
  const cn: IClassNames = classNames();
  const propsComponent: IMatchChangeTable = {
    variant: 'hp',
    matchList,
    trackingData,
  };

  // SERVER-SIDE should have NO GLIDER rendered! "react-glider" works only in BROWSER!
  return matchList.length > 0 ? (
    <NoSSR placeholder={ssrPlaceholder(propsComponent, cn)}>
      <div className={cn.wrapper}>
        <GliderWrapper {...argsGliderWrapper} propsComponent={propsComponent} />
      </div>
    </NoSSR>
  ) : null;
};

export default MatchChangeHp;
